/* Enhancements for native editable Shrine sections. Shopify owns commerce and forms. */
(()=>{
 const setup=(root=document)=>{
  root.querySelectorAll('[id^="ProductSubmitButton-"]').forEach(main=>{
   if(main.dataset.huStickyBound)return;
   main.dataset.huStickyBound='true';
   const product=main.closest('section');
   const sticky=product?.querySelector('.sticky-atc button[type=submit]');
   if(!sticky)return;
   const sync=()=>{
    const disabled=main.disabled||main.getAttribute('aria-disabled')==='true';
    sticky.disabled=disabled;
    sticky.setAttribute('aria-disabled',String(disabled));
    const label=main.querySelector('span'),target=sticky.querySelector('span');
    if(label&&target)target.textContent=label.textContent;
   };
   new MutationObserver(sync).observe(main,{attributes:true,attributeFilter:['disabled','aria-disabled'],childList:true,subtree:true,characterData:true});
   sync();
  });
  root.querySelectorAll('.collapsible-content details,.product__accordion details').forEach(details=>{
   if(details.dataset.huBound)return;
   details.dataset.huBound='true';
   details.addEventListener('toggle',()=>{
    const summary=details.querySelector('summary');
    if(summary)summary.setAttribute('aria-expanded',String(details.open));
    if(!details.open)return;
    const group=details.closest('.collapsible-content,.product__info-container');
    group?.querySelectorAll('details').forEach(other=>{if(other!==details)other.open=false});
   });
  });
 };
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>setup());else setup();
 document.addEventListener('shopify:section:load',event=>setup(event.target));
 document.addEventListener('keydown',event=>{
  if(event.key!=='Escape')return;
  const drawer=document.querySelector('cart-drawer.active');
  if(drawer)drawer.close();
 });
 document.addEventListener('click',event=>{
  const link=event.target.closest('#menu-drawer a[href]');
  if(link&&link.getAttribute('href').includes('#')){
   const drawer=link.closest('header-drawer');
   drawer?.closeMenuDrawer?.(event);
  }
 });
})();
